import React, { useEffect, useState } from "react";
import { IoSend } from "react-icons/io5";
import { FaClock, FaCloudUploadAlt, FaSearch, FaTrashAlt } from "react-icons/fa";
import ParentComponent from "../../Components/ParentComponent/ParentComponent";
import PrimaryHeader from "../../Components/PrimaryHeader/PrimaryHeader";
import DropDownCustom from "../../Components/DropDownCustom/DropDownCustom";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { MdEdit } from "react-icons/md";
import ConfirmDeleteModal from "../../Components/ConfirmDeleteModal/ConfirmDeleteModal";
import { createTask, deleteTaskReminder, updateTaskReminder, UploadImage } from "../../Actions/actions";
import { useDispatch } from "react-redux";
import AuthButton from "../../Components/AuthButton/AuthButton";
import { AiOutlineClose } from "react-icons/ai";
import Input from "../../Components/Input/Input";
import Loader from "../../Components/Loader/Loader";
import { IoIosSend } from "react-icons/io";

const TaskReminder = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formatDueDate = (date) => {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  };
  const location = useLocation();
  const { taskData } = location.state;
  const { loginData, employeesData, Privilages } = useSelector((state) => state.userReducer);

  const [searchQuery, setSearchQuery] = useState("");
  const [leadStatusFilter, setLeadStatusFilter] = useState("");
  const [leadSourceFilter, setLeadSourceFilter] = useState("");
  const [salesRepFilter, setSalesRepFilter] = useState("");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteid, setdeleteid] = useState("");
  const [task, setTask] = useState(null);
  const [isAssignmentModalOpen, setIsAssignmentModalOpen] = useState(false);

  // const tasks = [
  //   {
  //     task: "Follow up with ABC Corp",
  //     assignedTo: "John Doe",
  //     status: "Pending",
  //     dueDate: "10/30/2024",
  //     leadSource: "Referral",
  //   },
  //   {
  //     task: "Prepare proposal for XYZ Inc",
  //     assignedTo: "Emma Watson",
  //     status: "In Progress",
  //     dueDate: "10/25/2024",
  //     leadSource: "Website",
  //   },
  //   {
  //     task: "Follow up with DEF Ltd",
  //     assignedTo: "Sarah Miller",
  //     status: "Pending",
  //     dueDate: "11/05/2024",
  //     leadSource: "Social Media",
  //   },
  //   {
  //     task: "Schedule demo with GHI Co",
  //     assignedTo: "John Doe",
  //     status: "Pending",
  //     dueDate: "11/10/2024",
  //     leadSource: "Referral",
  //   },
  // ];

  const getStatusStyle = (status) => {
    if (status === "Pending") return "bg-yellow-100 text-yellow-700";
    if (status === "In Progress") return "bg-blue-100 text-blue-700";
    return "";
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  const filteredTasks = taskData.filter((task) => {
    console.log(task, 'pp');
    return (
      (task.title.toLowerCase().includes(searchQuery) ||
        task.assignedTo.toLowerCase().includes(searchQuery)) &&
      (leadStatusFilter === "" || task.status === leadStatusFilter) &&
      (leadSourceFilter === "" || task.leadSource === leadSourceFilter) &&
      (salesRepFilter === "" || task.employeeId === salesRepFilter)
    );
  });
  const leadStatusOptions = [
    { value: "", label: "All" },
    { value: "Pending", label: "Pending" },
    { value: "In Progress", label: "In Progress" },
  ];

  const leadSourceOptions = [
    { value: "", label: "All" },
    { value: "Referral", label: "Referral" },
    { value: "Website", label: "Website" },
    { value: "Social Media", label: "Social Media" },
  ];
  const salesRepOptions = [
    { value: "", label: "All" },
    ...employeesData?.map((source) => ({
      value: source.id,
      label: source.FullName,
    })),
  ];
  // const salesRepOptions = [
  //   { value: "", label: "All" },
  //   ...employeesData
  // ];
  const handleChanges = (selectedOption, setterFunction) => {
    setterFunction(selectedOption.value);
    console.log(selectedOption);
  };

  const handleDelete = (id) => {
    setdeleteid(id);
    setIsDeleteModalOpen(true);
  };
  const PrivilagesArray = Privilages?.length > 0 ? (Privilages.filter(
    (item) => item.feature === 'Dashboard'
  )) : []
  return (
    <ParentComponent>
      <PrimaryHeader />
      <div className="mb-6 flex md:flex-row sm:flex-col space-y-4 sm:space-y-0 sm:space-x-0 md:space-x-6 items-center self-center">
        <div className="relative md:w-3/6 sm:w-full mb-[15px] md:mb-0">
          <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search by task or assigned to"
            value={searchQuery}
            onChange={handleSearch}
            className="border border-gray-300 rounded-lg pl-10 pr-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-[#361D32]"
          />
        </div>

        <div className="md:mt-0 md:w-3/6 sm:w-full flex sm:flex-row sm:space-x-4 space-y-4 sm:space-y-0">
          <DropDownCustom
            isAligned={true}
            selectedValue={leadStatusOptions?.find(
              (option) => option.value === leadStatusFilter
            )}
            handleChanges={(option) =>
              handleChanges(option, setLeadStatusFilter)
            }
            options={leadStatusOptions}
            isSearchable={false}
            label="Lead Status"
            placeholder="Select Lead Status"
          />

          {/* <DropDownCustom
            isAligned={true}
            selectedValue={leadSourceOptions.find(
              (option) => option.value === leadSourceFilter
            )}
            handleChanges={(option) =>
              handleChanges(option, setLeadSourceFilter)
            }
            options={leadSourceOptions}
            isSearchable={false}
            label="Lead Source"
            placeholder="Select Lead Source"
          /> */}

          <DropDownCustom
            isAligned={true}
            selectedValue={salesRepOptions?.find(
              (option) => option.value === salesRepFilter
            )}
            handleChanges={(option) => handleChanges(option, setSalesRepFilter)}
            options={salesRepOptions}
            isSearchable={false}
            label="Assigned Sales Rep"
            placeholder="Select Sales Rep"
          />
        </div>
      </div>

      <div className="w-[100%] overflow-x-auto rounded-lg shadow-md bg-white relative sm:mb-20 md:mb-0">
        <table className="w-full text-left">
          <thead className="bg-[#361D3214]">
            <tr className="text-gray-500 text-sm">
              <th className="px-4 py-4 text-left text-sm font-semibold text-gray-600 min-w-[250px]">
                Task
              </th>
              <th className="px-4 py-4 text-left text-sm font-semibold text-gray-600 min-w-[200px]">
                Assigned To
              </th>
              <th className="py-4 text-center text-sm font-semibold text-gray-600 min-w-[160px]">
                Status
              </th>
              <th className="py-4 text-center text-sm font-semibold text-gray-600 min-w-[150px]">
                Due Date
              </th>
              <th className="py-4 text-center text-sm font-semibold text-gray-600 min-w-[150px]">
                Action
              </th>
            </tr>
          </thead>
          <tbody className="w-full  text-gray-800">
            {filteredTasks?.length > 0 ? (
              filteredTasks?.map((task, index) => (
                <tr key={index} className="w-full border-b last:border-none">
                  <td className="px-4 py-3">{task?.title}</td>
                  <td className="px-4 py-3">

                    <span className="text-sm bg-gray-100 text-gray-700 px-3 py-1 rounded">
                      {task?.assignedTo || 'Unknown'}
                    </span>
                  </td>
                  <td className="px-4 text-center">
                    <span
                      className={`text-sm px-3 py-1 rounded ${getStatusStyle(
                        task.status
                      )}`}
                    >
                      {task.status}
                    </span>
                  </td>
                  <td className="py-3 text-center">{moment(task.dueDate).format("DD-MMM-yy")}</td>
                  <td className="py-3">
                    <div className="flex items-center justify-center gap-2 h-full">

                      {PrivilagesArray?.length > 0 ?
                        (PrivilagesArray[0].accessLevel !== 'View Only' ?
                          (<button
                            className="text-gray-600 hover:text-yellow-500 bg-gray-100 p-2 rounded-full"
                            onClick={() => {
                              setTask(task)
                              setIsAssignmentModalOpen(true);
                            }}
                          >
                            <MdEdit />
                          </button>)
                          : null) :
                        (<button
                          className="text-gray-600 hover:text-yellow-500 bg-gray-100 p-2 rounded-full"
                          onClick={() => {
                            setTask(task)
                            setIsAssignmentModalOpen(true);
                          }}
                        >
                          <MdEdit />
                        </button>)}

                      {PrivilagesArray?.length > 0 ?
                        (PrivilagesArray[0].accessLevel == 'Full Access' ?
                          (<button
                            className="text-gray-600 hover:text-red-500 bg-gray-100 p-2 rounded-full"
                            onClick={() => {
                              handleDelete(task.id)
                            }}
                          >
                            <FaTrashAlt />
                          </button>)
                          : null) :
                        (<button
                          className="text-gray-600 hover:text-red-500 bg-gray-100 p-2 rounded-full"
                          onClick={() => {
                            handleDelete(task.id)
                          }}
                        >
                          <FaTrashAlt />
                        </button>)}


                      {task.status == 'Pending' ?
                        <button
                          className="text-gray-600 hover:text-blue-500 bg-gray-100 p-2 rounded-full"
                          onClick={() => { }}>
                          <IoIosSend />
                        </button>
                        : null}
                      {/* {task.status == 'Pending' ?
                      <button className="flex items-center text-gray-700 border border-gray-300 px-2 py-1 bg-gray-100 rounded hover:bg-gray-300">
                        <IoSend className="w-3 h-3 mr-1 text-black" />
                        <span className="text-sm">Remind</span>
                      </button>
                      : null} */}

                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center py-4 text-gray-500">
                  No tasks found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <ConfirmDeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => {
          setIsDeleteModalOpen(false);
        }}
        onConfirm={() => {
          dispatch(
            deleteTaskReminder(loginData?.accessToken, deleteid, () => {
              setIsDeleteModalOpen(false);
              navigate('/dashboard')
            })
          );
        }}
      />
      <UrgentAssignmentModal
        isOpen={isAssignmentModalOpen}
        onClose={() => setIsAssignmentModalOpen(false)}
        data={employeesData}
        taskData={task}
      />
    </ParentComponent>
  );
};

export default TaskReminder;

const UrgentAssignmentModal = ({ isOpen, onClose, data, taskData }) => {
  const navigate = useNavigate();

  const { loginData, subLoader } = useSelector(
    (state) => state.userReducer
  );
  const dispatch = useDispatch();
  const [filename, setfilename] = useState("")
  const [formData, setFormData] = useState({
    assignedToId: "",
    title: "",
    description: "",
    dueDate: "",
    dueTime: "",
    attachmentUrl: "",
    priority: ''

  });

  const [errors, setErrors] = useState({
    assignedToId: '',
    title: '',
    description: '',
    dueDate: '',
    dueTime: '',
    attachmentUrl: '',
    priority: ''

  });

  useEffect(() => {
    setfilename(taskData?.attachments[0]?.fileName)
    setFormData({
      assignedToId: taskData?.assignedTo,
      title: taskData?.title,
      description: taskData?.description,
      dueDate: taskData?.dueDate ? new Date(taskData?.dueDate)?.toISOString()?.split("T")[0] : new Date(),
      dueTime: taskData?.dueTime,
      priority: taskData?.priority,
      attachmentUrl: taskData?.attachments[0]?.filePath,
    })
  }, [isOpen, taskData])


  const validateForm = () => {
    let newErrors = {};

    if (!formData.assignedToId) {
      newErrors.assignedToId = "Sales Rep is required";
    }
    if (!formData.title) {
      newErrors.title = "Task is required";
    }
    if (!formData.description) {
      newErrors.description = "Details are required";
    }
    if (!formData.dueDate) {
      newErrors.dueDate = "Due Date is required";
    }
    if (!formData.dueTime) {
      newErrors.dueTime = "Time is required";
    }
    if (!formData.priority) {
      newErrors.priority = "Priority define is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };
  const priorityOptions = [
    { label: "High", value: "High" },
    { label: "Medium", value: "Medium" },
    { label: "Low", value: "Low" },
  ];

  const selectedValuePriority = priorityOptions?.find(
    (option) => option.value === formData.priority
  );
  const options = data?.map((value) => {
    return { label: value.FullName, value: value.id };
  });

  const selectedValue = options?.find(
    (option) => option.label === formData.assignedToId
  );

  if (!isOpen) return null;

  const handleFileChange = (e) => {
    setErrors({ ...errors, attachmentUrl: '' })
    const file = e.target.files[0];
    setfilename(file.name)
    if (file) {
      dispatch(UploadImage(file, '', (data) => {

        setFormData({ ...formData, attachmentUrl: data.data.fileUrl })
      }))

    }
  };

  const triggerFileUpload = () => {
    document.getElementById("fileUploadInput").click();
  };
  const handleChangesPriority = (selectedOption) => {
    setErrors((prevData) => ({ ...prevData, priority: '' }));

    setFormData((prevData) => ({ ...prevData, priority: selectedOption.value }));
  };
  const handleChanges = (selectedOption) => {
    setFormData((prevData) => ({ ...prevData, assignedToId: selectedOption.value }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleEdit = () => {
    let data = { ...formData }
    data['assignedToId'] = taskData?.employeeId;
    if (validateForm()) {
      dispatch(updateTaskReminder(taskData?.id, data, loginData?.accessToken, () => {
        onClose();
        navigate('/dashboard');
      })
      );
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 p-4 w-full">
      <div
        onClick={onClose}
        className="bg-gray-800 opacity-50 fixed inset-0"
      ></div>
      <div className="bg-white rounded-lg shadow-lg px-4 pt-4 w-[95%] md:w-[60%] relative">
        <div className="flex justify-between items-center ">
          <h2 className="text-xl font-bold">Urgent Assignment</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <AiOutlineClose />
          </button>
        </div>
        <DropDownCustom
          selectedValue={selectedValue}
          handleChanges={handleChanges}
          options={options}
          isSearchable={false}
          label="Sales Rep Selection"
          placeholder="Select Sales Rep"
        />

        <div className="mt-4">
          <Input
            type="text"
            label="Task"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            placeholder="Task"
            float={true}
            error={errors.title}
          />
        </div>

        <div className="mt-4">
          <Input
            textarea={true}
            placeholder="Enter details"
            label="Details"
            name="details"
            value={formData.description}
            onChange={(e) => {
              setFormData({ ...formData, description: e.target.value });
            }}
            error={errors.description}
          />
        </div>

        <div className="flex gap-4 mt-4">
          <div className="w-1/2">
            <div className="relative">
              <Input
                type="date"
                float={true}
                label="Due Date"
                name="dueDate"
                value={formData?.dueDate}
                onChange={handleInputChange}
                error={errors.dueDate}
              />
            </div>
          </div>
          <div className="w-1/2">
            <div className="relative">
              <Input
                type="time"
                float={true}
                label="Time"
                name="dueTime"
                value={formData?.dueTime}
                onChange={handleInputChange}
                error={errors.dueTime}
              />
              {/* <FaClock className="absolute top-5 right-3 text-gray-900" /> */}
            </div>
          </div>
        </div>
        <DropDownCustom
          selectedValue={selectedValuePriority}
          handleChanges={handleChangesPriority}
          options={priorityOptions}
          isSearchable={false}
          label="Priority"
          placeholder="Select priority"
        />
        {errors.priority !== '' && (
          <p className="text-red-500 text-sm mt-1">{errors.priority}</p>
        )}
        {/* Custom Dynamic File Upload */}
        <div
          className="mt-4 border border-dashed border-gray-300 p-6 rounded-lg text-center cursor-pointer"
          onClick={triggerFileUpload}
        >
          {formData.attachmentUrl ? (
            <div>
              <p className="text-gray-700 mb-2">
                Uploaded: {filename}
              </p>
              <button
                className="text-red-500 underline"
                onClick={() =>
                  setFormData((prevData) => ({
                    ...prevData,
                    attachmentUrl: null,
                  }))
                }
              >
                Remove File
              </button>
            </div>
          ) : (
            <div>
              <FaCloudUploadAlt
                className="text-gray-400 mx-auto mb-2"
                size={40}
              />
              <p className="text-gray-500">Click to upload file</p>
            </div>
          )}
          {/* Hidden File Input */}
          <input
            id="fileUploadInput"
            type="file"
            className="hidden"
            onChange={handleFileChange}
          />
          {errors.attachmentUrl !== '' && (
            <p className="text-red-500 text-sm mt-1">{errors.attachmentUrl}</p>
          )}
        </div>

        <div className="flex justify-end mt-6 space-x-4">
          <AuthButton
            onClick={onClose}
            className="bg-white px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100"
            width="20%"
            title="Cancel"
          />
          {subLoader ? (
            <Loader />
          ) : (
            <AuthButton
              width="20%"
              title="Edit"
              className="px-4 py-2 text-white rounded-md"
              onClick={handleEdit}
            />
          )}

        </div>
      </div>
    </div>
  );
};
